module.exports = __webpack_public_path__ + "img/rf2.74d11b98.png";